export enum ENavClickedEventName {
  NAV_CLICKED = 'Nav Clicked',
}

export interface INavClickedEvent {
  clickedLink: string;
  isInDropdown: boolean;
  dropdownHeader?: string;
}
